import React from "react";

export const useChangeTitleAppBar = (title) => {
  React.useEffect(() => {
    document.getElementById("appBar-dark-title").innerText = title.toString();
  }, [title]);
};
